import React from 'react';

import { DepopCommunity } from '@depop/web-thrift-ui/Illustrations/DepopCommunity';
import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { HELP_ARTICLES } from '@/constants/helpUrls.ts';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';

type Props = {
  productId: number;
  sellerId: number;
};

export function DepopProtectionNotice({ productId, sellerId }: Props) {
  const t = useTranslations('checkout');
  const { sendActivityTrackerEvent } = useActivityTracker();

  function handleProtectionClick() {
    sendActivityTrackerEvent(
      ActivityTrackerEventType.BUYER_PROTECTION_LINK_ACTION,
      {
        productId,
        sellerId,
        schemaVersion: '1.0',
      }
    );
  }

  return (
    <div className={styles.protection}>
      <DepopCommunity size="xSmall" />
      <Caption variant="sm-regular" colour="subtle">
        {t.rich('OrderSummaryDepopProtection', {
          anchor: (chunk) => (
            <a
              href={HELP_ARTICLES.BUYER_PROTECTION}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleProtectionClick}
              className={styles.protectionLink}
            >
              {chunk}
            </a>
          ),
        })}
      </Caption>
    </div>
  );
}
